// src/pages/About.js
import React from "react";
import "./About.css";
import founderImg from "../../assets/Images/user.jpg";

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
    <div className="about-indvo-container">
  <h1>About Indvo</h1>
  <p>Your Sourcing Agent & Business Expansion Partner in India</p>

  {/* Updated Stats Container */}
  <div className="stats-container glass-effect">
    <div className="stat">
      <h2>4+</h2>
      <p>Years Experience</p>
    </div>
    <div className="stat">
      <h2>500+</h2>
      <p>Products Sourced</p>
    </div>
    <div className="stat">
      <h2>50+</h2>
      <p>Happy Clients</p>
    </div>
    <div className="stat">
      <h2>25+</h2>
      <p>Countries Served</p>
    </div>
  </div>

  
</div>


      {/* Who We Are */}
      <section className="who-we-are">
        <h2>Who We Are</h2>
        <div className="who-wrapper">
          <div className="who-left">
            <p>
              At Indvo, we specialize in helping international businesses source high-quality products
              from India and expand into the Indian market with ease. Whether you're looking to launch
              your brand in India or simply want a reliable partner to manage product sourcing —
              we're here to make it happen.
            </p>
            <p>
              We're not just a connector. We are your <span className="highlight-blue">trusted sourcing agent</span>,
              <span className="highlight-orange"> business strategist</span>, and
              <span className="highlight-green"> growth partner</span> — all in one.
            </p>
          </div>
          <div className="who-right">
            <div className="feature-card blue">
              <i className="fa-solid fa-handshake"></i>
              <h4>Trusted Partner</h4>
              <p>Your reliable business ally in India</p>
            </div>
            <div className="feature-card orange">
              <i className="fa-solid fa-chart-line"></i>
              <h4>Growth Focused</h4>
              <p>Strategies for sustainable expansion</p>
            </div>
            <div className="feature-card green">
              <i className="fa-solid fa-shield-halved"></i>
              <h4>Quality Assured</h4>
              <p>Rigorous quality control processes</p>
            </div>
            <div className="feature-card dark">
              <i className="fa-solid fa-globe"></i>
              <h4>Global Reach</h4>
              <p>Connecting businesses worldwide</p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="founder-section">
        <h2>Meet the Founder</h2>
        <div className="founder-card">
          <div className="founder-info">
            <h3>Sharad Pawar</h3>
            <p className="founder-role">Founder & CEO</p>
            <p>
              I'm Sharad Pawar, the founder of Indvo and Utkrst Overseas. For over 4 years, I’ve helped
              brands around the world build their supply chains in India, develop cost-effective private
              labels, and unlock new revenue by entering the Indian market strategically.
            </p>
            <p>
              With deep industry knowledge, a strong supplier network, and a commitment to results, I
              help you avoid the typical sourcing struggles — poor communication, delays, low quality —
              and instead give you peace of mind and profitable growth.
            </p>
            {/* <div className="tags">
              <span className="tag tag-blue">Supply Chain Expert</span>
              <span className="tag tag-orange">Market Strategist</span>
              <span className="tag tag-green">Business Growth</span>
            </div> */}
          </div>
          <div className="founder-image">
            <img src={founderImg} alt="Sharad Pawar" />
            
          </div>
          
        </div>

   <div className="connect-section">
  <div className="connect-card">
    <h3 className="connect-title">Connect With Me</h3>
    <div className="social-card-row">
      <a
        href="https://wa.me/919407861249?text=Hello%20Indvo"
        target="_blank"
        rel="noopener noreferrer"
        className="social-card whatsapp"
      >
        <i className="fab fa-whatsapp"></i>
        <span>WhatsApp</span>
      </a>

      <a
        href="https://www.instagram.com/iindvo/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-card instagram"
      >
        <i className="fab fa-instagram"></i>
        <span>Instagram</span>
      </a>

      <a
        href="http://linkedin.com/company/indvo"
        target="_blank"
        rel="noopener noreferrer"
        className="social-card linkedin"
      >
        <i className="fab fa-linkedin"></i>
        <span>LinkedIn</span>
      </a>

      <a
        href="https://www.youtube.com/@iINDVO"
        target="_blank"
        rel="noopener noreferrer"
        className="social-card youtube"
      >
        <i className="fab fa-youtube"></i>
        <span>YouTube</span>
      </a>
    </div>
  </div>
</div>


      </section>


      {/* What We Do */}
      <section className="what-we-do">
        <h2>What We Do at Indvo</h2>
        <p className="subtitle">
          We provide comprehensive solutions to help your business thrive in the Indian market
        </p>
        <div className="services">
          <div className="service-card blue">
            <div className="icon-box">🔍</div>
            <h4>Expert Sourcing Services</h4>
            <ul>
              <li>Find the right manufacturers for your product category</li>
              <li>Verify and audit suppliers to ensure quality and reliability</li>
              <li>Negotiate best pricing and terms to maximize your margin</li>
              <li>Handle sampling, production tracking, and pre-shipment inspection</li>
            </ul>
          </div>
          <div className="service-card orange">
            <div className="icon-box">🌐</div>
            <h4>Indian Market Expansion</h4>
            <ul>
              <li>Research your product's fit in India</li>
              <li>Develop market entry strategies</li>
              <li>Offer distribution, fulfillment, and growth management</li>
              <li>No infrastructure needed on your part</li>
            </ul>
          </div>
          <div className="service-card green">
            <div className="icon-box">⚙️</div>
            <h4>End-to-End Execution</h4>
            <ul>
              <li>We manage everything: sourcing, logistics, packaging</li>
              <li>Sales channels management</li>
              <li>Complete hands-off approach for you</li>
              <li>Full transparency and reporting</li>
            </ul>
          </div>
        </div>
      </section>

     <section className="final-section-container">
      <h2 className="main-heading">Let’s Partner for Global Growth</h2>
      <div className="card-wrapper">
        {/* Card 1 - Utkrst Overseas */}
        <div className="info-card">
          <h3>What is Utkrst Overseas?</h3>
          <p>
            Utkrst Overseas is our second venture — simplifying export & import operations globally.
          </p>
          <ul>
            <li>Export & import management</li>
            <li>Supplier coordination</li>
            <li>Reliable and transparent logistics</li>
            <li>Network of verified producers</li>
          </ul>
        </div>

        {/* Card 2 - Why Work With Indvo */}
        <div className="info-card">
          <h3>Why Work With Indvo?</h3>
          <p>
            We’re not just agents — we’re your eyes and ears in India. We understand the culture,
            the market, and the suppliers. Indvo is your shortcut to results.
          </p>
        </div>

        {/* Card 3 - Contact */}
        <div className="info-card">
          <h3>Let’s Work Together</h3>
          <div className="contact-info">
            <p>📞 +91-9407861249</p>
            <p>📩 Contact@indvo.com</p>
            <p>🏢 Behind Mata Mandir, Chhindwara, MP 480001</p>
          </div>
          <div className="social-tags">
            <span>#indvo</span>
            <span>#utkrstoverseas</span>
            <span>#sharadpwr</span>
          </div>
        </div>
      </div>
    </section>

     
    </div>
  );
};

export default About;
